export const ADD_USER = 'USERS::ADD';
export const ADD_USERS = 'USERS::ADD::MANY';
export const UPDATE_USER = 'USERS::UPDATE';
export const REMOVE_USER = 'USERS::REMOVE';
export const START_LOADING = 'USERS::START-LOADING';
export const END_LOADING = 'USERS::END-LOADING';
export const OPEN_MODAL = 'USERS::OPEN-MODAL';
export const CLOSE_MODAL = 'USERS::CLOASE-MODAL';
export const SNAP_TIMESTAMP = 'SNAP_TIMESTAMP';
export const START_EDIT_USER = 'USERS::START-EDIT';
export const EDIT_USER = 'USERS::EDIT';




// WEBPACK FOOTER //
// ./src/actions/types.js